import { useState, useEffect } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@foundation/components/ui/dialog';
import { Button } from '@foundation/components/ui/button';
import { Textarea } from '@foundation/components/ui/textarea';

export type DocumentRegenerateDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRegenerate: (userContext: string) => void;
  isRegenerating?: boolean;
};

export const DocumentRegenerateDialog = ({ open, onOpenChange, onRegenerate, isRegenerating = false }: DocumentRegenerateDialogProps) => {
  const [context, setContext] = useState('');

  useEffect(() => {
    if (!open) setContext('');
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-4 w-4" /> Regenerate entire document</DialogTitle>
          <DialogDescription>Add any instructions or context. The AI rewrites the whole policy, keeping its structure and compliance language.</DialogDescription>
        </DialogHeader>
        <Textarea
          value={context}
          maxLength={4000}
          placeholder="e.g. Make it stricter on contractor safety; align to ISO 45001; add a section on incident reporting…"
          onChange={(e) => setContext(e.target.value.slice(0, 4000))}
          rows={5}
        />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={isRegenerating}>Cancel</Button>
          <Button onClick={() => onRegenerate(context.trim())} disabled={isRegenerating}>
            {isRegenerating ? <><Loader2 className="h-4 w-4 animate-spin mr-2" /> Regenerating…</> : 'Regenerate document'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
